import type { ApplyInvitesDone } from '@/types';

// app/(public)/26-co/invite/[handle]/done/page.tsx.
export default function Done({ leaderHandle }: ApplyInvitesDone) {
  return (
    <>
      <div className="mx-auto max-w-md space-y-6 px-4 py-16 text-center">
        <h1 className="font-bold text-2xl uppercase tracking-wide">
          ¡Te sumaste al equipo!
        </h1>
        <p className="text-muted-foreground">
          Cuando todos completen su perfil, el líder
          {leaderHandle ? ` (@${leaderHandle})` : ''} podrá enviar la
          postulación.
        </p>
        <p className="text-muted-foreground text-sm">
          Te avisaremos por mail cuando esté lista.
        </p>
      </div>
    </>
  );
}
